import { type FrankfurtCardPassenger } from "../types";

// Full name of the first traveller, used to prefill the guest name on the summary screen.
export const getFirstTravelerName = (passengerList: FrankfurtCardPassenger[] | null | undefined): string => {
  const firstTraveler = passengerList?.[0];

  return [firstTraveler?.firstName, firstTraveler?.lastName]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(" ");
};
